const  SOLUTION_STATUS ={
CANCELLED:"Cancelled"
}
const APP_CANCELLED_TEXT = "This app is cancelled!";
const APP_CERTIFICATION_TEXT = "This app is not yet certified!";
const LOADING_TEXT = "Fetching solution details...";
const BULK_SUBSCRIPTION_APP_CANCELLED_TEXT = "You cannot request bulk subscription for a cancelled app."

const getTypeOfApis = (apiType) => {
  if (apiType === "api") return "Rest";
  if (apiType === "async-api") return "Async";
  return apiType;
};
const capitalizeVisibility = (str) => {
  return str ? str[0].toUpperCase() + str.slice(1) : undefined;
};

const API_INTEGRATION_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending'
}

const API_TYPES = {
  REST: 'api',
  ASYNC: 'async-api'
}
const BUNDLE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  RETIRED: 'retired',
}

const BUNDLE_TYPE = {
  PRICE: "price",
  GENERAL: "general",
};

const CSV_FILE = {
  APP_API_INTEGRATION_ID: 'app-api-integration',
  APP_API_INTEGRATION_FILE_NAME: 'App API Integrations',
  SUBSCRIBER_ORGANIZATION_ID: 'subscriber-organization',
  SUBSCRIBER_ORGANIZATION_FILE_NAME: 'Subscriber Organizations'
}

const PLAN_VISIBILITY = {
  PUBLIC: 'public',
  PRIVATE: 'private'
}

const PLAN_TYPE = {
  SUBSCRIPTION: 'subscription',
  ADVANCED: 'advanced'
}

const PLAN_STATUS = {
  ACTIVE: 'active',
  RETIRED: 'retired'
}

const BUNDLE_PLAN_OPTIONS = [
  {
    label: "Location Based",
    value: "subscription"
  },
  {
    label: "Subscription with Overage",
    value: "advanced"
  }
]

const BUNDLE_PLAN_TYPES = Object.fromEntries(
  BUNDLE_PLAN_OPTIONS.map(({ value, label }) => [value, label]),
);

const ADVANCE_PLAN_CHANGE = {
  PLAN_NAME: "PLAN_NAME",
  PLAN_VISIBILITY: "PLAN_VISIBILITY",
  INSTALL_ENABLE: "INSTALL_ENABLE",
  INSTALL_FEE: "INSTALL_FEE",
  INSTALL_FEE_CATALOG: "INSTALL_FEE_CATALOG",
  MONTH_FEE: "MONTH_FEE",
  PLAN_TYPE: "PLAN_TYPE",
  PLAN_CATALOG: "PLAN_CATALOG",
  PLAN_OVERAGE_CATALOG: "PLAN_OVERAGE_CATALOG",
  PLAN_TOGGLE: "PLAN_TOGGLE"
}

const SUB_PLAN_CHANGE = {
  TITLE: "TITLE",
  BASE_VALUE: "BASE_VALUE",
  DESCRIPTION: "DESCRIPTION",
  RADIO: "RADIO",
  CONTAINER_QUOTA_LIMIT: "CONTAINER_QUOTA_LIMIT",
  CONTAINER_OVERAGES: "CONTAINER_OVERAGES",
  RESET: "RESET"
}

const INDICATOR_COLORS = {
  ISV: {
    borderColor: "rgba(107, 37, 116, 1)",
    backgroundColor: "rgba(240, 233, 241, 1)",
  },
  DLR: {
    borderColor: "rgba(7, 79, 175, 1)",
    backgroundColor: "rgba(230, 237, 247, 1)",
  },
  OEM: {
    borderColor: "rgba(250, 156, 25, 1)",
    backgroundColor: "rgba(254, 240, 220, 1)",
  },
  active: {
    borderColor: "rgba(9, 173, 0, 1)",
    backgroundColor: "rgba(218, 242, 217, 1)",
  },
  inactive: {
    borderColor: "rgba(196, 198, 200, 1)",
    backgroundColor: "rgba(243, 243, 244, 1)",
  },
};

const ORG_TYPE_OPTIONS = [
  { id: "orgtype-isv", label: "ISV", value: "ISV" },
  { id: "orgtype-dealer", label: "Dealer", value: "DLR" },
  { id: "orgtype-oem", label: "OEM", value: "OEM" },
];

const VISIBILITY_OPTIONS = [
  { id: "visibility-public", label: "Public", value: "public" },
  { id: "visibility-private", label: "Private", value: "private" },
];

const FILTER_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const ORG_TYPE_FILTER = {
  ISV: (api) => api?.visibility?.toLowerCase() !== "public",
  DLR: (api) => api?.dlr_visibility?.toLowerCase() !== "public",
  OEM: (api) => api?.oem_visibility?.toLowerCase() !== "public",
};

const RETIREMENT_TYPE = {
  WHOLE: 'whole',
  TIER: 'tier',
  NONE: 'none'
};

const RETIREMENT_MESSAGES = {
  WHOLE: "Changing these details will retire your entire pricing plan and create a new one. Do you want to proceed?",
  TIER: "Changing these details will retire the affected pricing plan(s) and create new ones. Do you want to proceed?"
};

const BUNDLE_ERROR_TITLES = {
  DELETION_FAILED: "Bundle Deletion Failed",
  ACTIVATION_FAILED: "Bundle Activation Failed",
  DEACTIVATION_FAILED: "Bundle Deactivation Failed",
  DEFAULT: "Operation Failed",
};

const BUNDLE_ERROR_CONTEXTS = {
  DELETE: "Failed to delete API Bundle",
  ACTIVATE: "Failed to activate API Bundle",
  DEACTIVATE: "Failed to deactivate API Bundle",
  DEFAULT: "Failed to update API Bundle Status",
};

const BUNDLE_DOC_TYPES = {
  TERMS: "terms",
  EXTERNAL: "external",
};

export {
    SOLUTION_STATUS,
    APP_CANCELLED_TEXT,
    APP_CERTIFICATION_TEXT,
    LOADING_TEXT,
    BULK_SUBSCRIPTION_APP_CANCELLED_TEXT,
    API_INTEGRATION_STATUS,
    API_TYPES,
    CSV_FILE,
    BUNDLE_STATUS,
    BUNDLE_TYPE,
    PLAN_VISIBILITY,
    PLAN_TYPE,
    PLAN_STATUS,
    BUNDLE_PLAN_OPTIONS,
    BUNDLE_PLAN_TYPES,
    ADVANCE_PLAN_CHANGE,
    SUB_PLAN_CHANGE,
    INDICATOR_COLORS,
    ORG_TYPE_OPTIONS,
    VISIBILITY_OPTIONS,
    FILTER_OPTIONS,
    ORG_TYPE_FILTER,
    RETIREMENT_TYPE,
    RETIREMENT_MESSAGES,
    BUNDLE_ERROR_TITLES,
    BUNDLE_ERROR_CONTEXTS,
    BUNDLE_DOC_TYPES,
    getTypeOfApis,
    capitalizeVisibility
}